import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import MoreOptionsVert from '@elliemae/ds-icons/MoreOptionsVert';
import { DSIconColors, DSIconSizes } from '@elliemae/ds-basic/Icon';
import GripperVertical from '@elliemae/ds-icons/GripperVertical';

var DragContainerController = function DragContainerController(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? DSIconColors.NEUTRAL : _ref$color,
      _ref$icon = _ref.icon,
      Icon = _ref$icon === void 0 ? GripperVertical : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DSIconSizes.S : _ref$size,
      _ref$multipleSize = _ref.multipleSize,
      multipleSize = _ref$multipleSize === void 0 ? false : _ref$multipleSize,
      onClick = _ref.onClick;

  var _convertPropToCssClas = convertPropToCssClassName('query-builder-drag-group'),
      cssClassName = _convertPropToCssClas.cssClassName;

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(cssClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    size: size
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement(MoreOptionsVert, {
    color: color,
    onClick: onClick,
    size: size
  }), multipleSize && /*#__PURE__*/React.createElement(Icon, {
    className: "additional-drag",
    color: color,
    onClick: onClick,
    size: size
  }));
};

export default DragContainerController;
//# sourceMappingURL=DragContainerController.js.map
